/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */

import React, { useState, useContext, useEffect } from "react"
import { useQuery, useMutation } from "@apollo/client"
import { v4 } from "uuid"
import { toast } from "react-toastify"

import { formatPrice } from "utils/mapProductsFormAnalytics"

import { AppContext } from "components/Context/AppContext"
import CheckboxMark from "components/CheckboxMark/CheckboxMark"
import usePrivateDeliveryNotice from "hooks/usePrivateDeliveryNotice"
import { getFormattedCart, getUpdatedItems } from "utils/functions"

import GET_CART from "queries/get-cart"
import ADD_TO_CART from "mutations/add-to-cart"
import UPDATE_CART from "mutations/update-cart"

const AddToCartCheckbox = ({ product, parentId = null }) => {
  const [cart, setCart] = useContext(AppContext)
  const [productAdded, setProductAdded] = useState(false)
  const [productCartKey, setProductCartKey] = useState(null)
  const deliveryNoticePending = usePrivateDeliveryNotice()

  const productQtyInput = {
    clientMutationId: v4(),
    productId: product?.databaseId,
  }
  
  if (parentId) {
    productQtyInput.extraData = JSON.stringify({
      parentId: parentId
    })
  }
  useEffect(() => {
    if (!cart || !product || !parentId) return;

    const inCart = cart.products.some(inCart => inCart.productId === product?.databaseId && inCart.parentId === parentId);

    if (inCart && !productAdded)
      setProductAdded(true);
  }, [cart]);

  // Get Cart Data
  const { data, refetch } = useQuery(GET_CART, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      const updatedCart = getFormattedCart(data)
      localStorage.setItem("woo-next-cart", JSON.stringify(updatedCart))

      setCart(updatedCart)
    },
    onError: error => {
      console.warn(error)
    },
  })

  // Add to Cart Mutation
  const [addToCart, { loading: addToCartLoading, error: addToCartError }] =
    useMutation(ADD_TO_CART, {
      variables: {
        input: productQtyInput,
      },
      onCompleted: data => {
        if (addToCartError) {
          toast.error("Wystąpił błąd")
          console.warn(addToCartError.graphQLErrors[0].message)
        } else {
          const item = data?.addToCart?.cartItem
          if (item) {
            window.dataLayer.push({ ecommerce: null })
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: "PLN",
                value: parseInt(formatPrice(item.product.node.price)),
                items: [
                  {
                    item_id: item.product.node.databaseId,
                    item_name: item.product.node.name,
                    price: parseInt(formatPrice(item.product.node.price)),
                    item_brand:
                      item.product.node.paProducents?.nodes
                        ?.map(({ name }) => name)
                        .join(",") || "",
                    item_category:
                      item.product.node.productCategories?.nodes
                        ?.map(({ name }) => name)
                        .join(",") || "",
                    quantity: 1,
                  },
                ],
              },
            })
          }
        }

        toast.success(`Produkt został rozbudowany o ${product.name}`)
        refetch()
      },
      onError: error => {
        if (error) {
          toast.error("Wystąpił błąd")
          console.warn(error)
        }
      },
    })

  // Update Cart Mutation
  const [updateCart] = useMutation(UPDATE_CART, {
    onCompleted: () => {
      toast.warning(`Rozszerzenie ${product.name} zostało usunięte z produktu.`)
      refetch()
    },
    onError: error => {
      if (error) {
        toast.error("Wystąpił błąd")
        console.warn(error.graphQLErrors[0].messagee)
      }
    },
  })

  // Handle remove product click
  const handleRemoveProductClick = (event, cartKey, products) => {
    event.stopPropagation()
    if (products.length) {
      // By passing the newQty to 0 in updateCart Mutation, it will remove the item.
      const newQty = 0
      const updatedItems = getUpdatedItems(products, newQty, cartKey)

      updateCart({
        variables: {
          input: {
            clientMutationId: v4(),
            items: updatedItems,
          },
        },
      })
    }
  }

  // Find choosen product cartKey and match
  const findProductCartKey = (cart, product) => {
    cart &&
      cart.products.map(item => {
        item.productId === product.databaseId && setProductCartKey(item.cartKey)
      })
  }

  useEffect(() => {
    findProductCartKey(cart, product)
  }, [cart, product])

  return (
    <CheckboxMark
      name={product.databaseId}
      checked={productAdded}
      onChange={e => {
        if (deliveryNoticePending) return
        setProductAdded(!productAdded)
        !productAdded
          ? addToCart()
          : handleRemoveProductClick(e, productCartKey, cart.products)
      }}
    >
      {addToCartLoading
        ? "Dodawanie..."
        : `${product.name} (+${product.price})`}
    </CheckboxMark>
  )
}

export default AddToCartCheckbox
